import api from './client'

/**
 * Qué filtros ve el cliente en cada categoría de la tienda. Los valores de
 * cada filtro salen de Presea; acá solo se prende o apaga el filtro entero.
 */
export const webFiltrosApi = {
  categorias: () => api.get('/web/filtros'),
  filtros: (categoria) => api.get(`/web/filtros/${categoria}`),
  cambiar: (categoria, filtro, visible) => api.put(`/web/filtros/${categoria}`, { filtro, visible }),
}
